$(document).ready(function (){
    $("#table-coupons").DataTable({
        proccesing: true,
        serverSide: true,
        language: {
            url: "https://cdn.datatables.net/plug-ins/2.0.3/i18n/es-ES.json"
        },
        responsive: true,
        ajax: '/admin/get-coupons',
        columns: [
            {data: 'id', name: 'id'},
            {data: 'description', description: 'name'},
            {data: 'code', name: 'code'},
            {data: 'type', name: 'type'},
            {data: 'value', name: 'value'},
            {data: 'fecha_inicio', name: 'fecha_inicio'},
            {data: 'fecha_fin', name: 'fecha_fin'},
        ],
        "columnDefs": [{
            "targets": 7,
            "data": "download_link",
            "render": function (data, type, row, meta) {
                let status = get_global_status(row.status);
                return '<a href="#" data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
                    'class="btn btn-' + status.color_clas + ' change-coupon-status btn-sm m-1"  ' +
                    'data-id ="' + row.id + '"><span class="' + status.icon + '"></span></a> ' +

                    '<button data-toggle="tooltip" data-placement="top" title="Editar" class="btn button_almadia_reverse ' +
                    'edit-coupon btn-sm m-1"' +
                    'data-data ="' + row + '"><i class="far fa-edit"></i></i></button> ' + button_coupon_delete(row.status,row.id)
            }
        }]
    })
    const list_coupons = $("#table-coupons").DataTable()

    function button_coupon_delete(status,id) {
        if (status === "D") {
            return button = '<a href="#" data-toggle="tooltip" data-placement="top" title="Eliminar" ' +
                'class="btn btn-danger delete-coupon btn-sm m-1"  ' +
                'data-id ="' + id + '"><i class="fa-solid fa-trash-can-arrow-up"></i></a> ' ;
        }
        return "";
    }

    $("#add-coupons").on('click',function (e){
        e.preventDefault()
        $("#text-modal-coupons").html('Ingresar nuevo cupón')
        $("#modal-coupons").modal('show')
        $(".item-coupon-dir").val('add')
    })

    $("#table-coupons tbody").on('click','.change-coupon-status',function (e){
        e.preventDefault();
        let data = new FormData()
        data.append('id',$(this).data('id'))
        sendData(data,'/admin/update-coupons-status')
    })

    $("#table-coupons tbody").on('click','.delete-coupon',function (e){
        e.preventDefault();
        let data = new FormData()
        data.append('id',$(this).data('id'))
        swal.fire({
            title: "¿Estas seguro?",
            text: "Tu registro sera eliminado",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                sendData(data,'/admin/delete-coupon')
            }
        })
    })

    $("#table-coupons tbody").on('click','.edit-coupon',function (e){
        let data = $(this).data('data')
        $(".item-coupon-dir").val('edit')
        $("#modal-coupons").modal('show')
        rowData = list_coupons.row($(this).parents('tr')).data();
        $.each(rowData, function (index, value) {
            if (index === "type") {
                setValue(value)
            }
            $(".item-" + index).val(value)
        })
    })

    $("#form-coupons").on('submit', function (e){
        e.preventDefault()
        let data = new FormData(this)
        let dir = $(".item-coupon-dir").val();
        sendData(data,'/admin/'+dir+'-coupon','')
    })

    function sendData(data, route) {
        $(".loader_").addClass("loading")
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {

                setTimeout(function () {
                    $("#modal-coupons").modal('hide')
                    $(".loader_").removeClass("loading")
                    $("#table-coupons").DataTable().ajax.reload();
                    alertSuccess(response.msg)
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $(".loader_").removeClass("loading")
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }

    function setValue(value) {
        if (value === "Porcentaje") {
            $( ".item-type_p" ).prop( "checked", true );
            $( ".item-type_m" ).prop( "checked", false );
        }else {
            $( ".item-type_m" ).prop( "checked", true );
            $( ".item-type_p" ).prop( "checked", false );
        }
    }

    window.selectValue = function (type) {
        if (type == "Porcentaje") {
            $(".text-value-type").html('Ingresar porcentaje')
            $('.item-value').attr('placeholder', 'Ingresar porcentaje');

        }else{
            $(".text-value-type").html('Ingresar monto')
            $('.item-value').attr('placeholder', 'Ingresar monto');
        }
    }



})
